














































































import Vue from 'vue'
import { defaultPosterImage } from '@/helper/constants'
import NewProductCard from '@/components/product/NewProductCard.vue'
export default Vue.extend({
  components: { NewProductCard },
  props: {
    products: {
      type: Array
    }
  },
  data() {
    return {
      defaultPosterImage,
      leftClickEnabled: false,
      rightClickEnabled: false,
      leftIndex: 0,
      rightIndex: 2,
      productList: [],
      activeProduct: null,
      maxLength: 3
    }
  },
  mounted() {
    this.getProductList()
  },
  methods: {
    getProductList() {
      const list = []
      let i = 0
      if (screen.width < 760) {
        this.maxLength = 1
        this.rightIndex = 1
      } else if (screen.width < 840) {
        this.maxLength = 2
        this.rightIndex = 2
      }
      for (; i < this.products.length && i < this.maxLength; i++) {
        list.push(this.products[i])
      }
      this.activeProduct = this.products[0]?.id
      this.productList = [...list]
      if (i < this.products.length) {
        this.rightClickEnabled = true
        this.rightIndex = i
      }
    },
    scroll(scrollType: string) {
      const list = [...this.productList]
      if (scrollType === 'left') {
        if (!this.leftClickEnabled) {
          return
        }
        list.pop()
        list.splice(0, 0, this.products[--this.leftIndex])
        this.rightIndex--
        if (this.rightIndex < this.products.length) {
          this.rightClickEnabled = true
        }
        if (this.leftIndex == 0) {
          this.leftClickEnabled = false
        }
      } else {
        if (!this.rightClickEnabled) {
          return
        }
        list.shift()
        list.push(this.products[this.rightIndex++])
        this.leftIndex++
        if (this.rightIndex >= this.products.length) {
          this.rightClickEnabled = false
        }
        if (this.leftIndex > 0) {
          this.leftClickEnabled = true
        }
      }
      this.productList = []
      this.productList = [...list]
      this.changeSelectedProductIndex(list[0].id)
    },
    changeSelectedProductIndex(id: string) {
      this.activeProduct = id
      this.$emit('change-selected-product', id)
    }
  },
  filters: {
    truncateText(text: string): string {
      const MAX_LENGTH = 20
      if (text.length < MAX_LENGTH) return text
      return text.slice(0, MAX_LENGTH) + '...'
    }
  }
})
